import { AxiosService } from '../../services/axiosService';

export const getPartNumberNonPagingApi = (formulaId, options) => {
  return AxiosService.get(`formula/${formulaId}/part-number/non-paging`, {
    filter: options.filter
  });
};
